import { useState } from 'react';
import { useHistory } from 'react-router-dom';

const useSidebarMenu = () => {
  const history = useHistory();
  const [active, setActive] = useState('visits-section');

  const handleSidebarClick = (activeSection, activePath) => {
    setActive(activeSection);
    history.push(activePath);
  };

  return {
    active,
    handleSidebarClick,
  };
};

export default useSidebarMenu;
